import { useRef, useState } from 'react';
import styles from './styles.module.scss';
import { Icons } from '../../../icons/index';
import { Popover } from 'components-antd';
import { Icons as Icon } from 'components/ClientsDrawer/ProfileClient/ExpandedSection/Clients/components/ClientsList/Client/Options/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { appSetConnectionTypeAction, appSetShowAssignConnectionAction } from 'store/actions/app';
import { AGENT, TEAM_BASIC } from 'settings/constants/roles';
import { AGENT_CONNECTIONS } from 'settings/constants/drawers';
import { getActiveTeamList } from 'store/selectors/teamList';
import { Avatar } from 'components';
import { convertNameToAvatarPlaceholder } from 'helpers';
import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';
import { getUserId } from 'store/selectors/user';

const AssignedAdmins = (props) => {
  const { contact } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const buttonRef = useRef<HTMLInputElement>(null);
  const optionsRef = useRef<HTMLInputElement>(null);
  const activeTeamList = useSelector(getActiveTeamList);
  const applicableList =
    activeTeamList
      ?.filter((member) => contact?.AdminsIds?.includes(member.id))
      .filter((member) => member.id !== contact?.Id) ?? [];
  const agentRole = useSelector(getAgentTeamRoleSelector);
  const userId = useSelector(getUserId);
  const limitedAccess = userId === contact.Id && agentRole === TEAM_BASIC;

  const onClickOptions = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <p className={styles.title}>Assigned Admin(s)</p>
        {limitedAccess ? null : (
          <span ref={buttonRef} onClick={onClickOptions}>
            <Icons variant={Icons.MENU} />
          </span>
        )}
        <Popover
          open={open}
          overlayClassName={styles.assignedAdminsOptionsPopover}
          content={
            <div ref={optionsRef} className={styles.options}>
              <ul
                className={styles.dropdown}
                onClick={() => {
                  setOpen(!open);
                  dispatch(appSetConnectionTypeAction({ type: AGENT_CONNECTIONS.Team }));
                  dispatch(
                    appSetShowAssignConnectionAction({
                      open: true,
                      assignType: AGENT,
                      newInvite: false,
                    }),
                  );
                }}
              >
                <li testid="reassign_action" className={styles.item} onClick={(e) => {}}>
                  <div className={styles.icon}>
                    <Icon variant={Icon.REASSIGN} />
                  </div>
                  <span>Reassign</span>
                </li>
              </ul>
            </div>
          }
        ></Popover>
      </div>
      <div className={styles.content}>
        {applicableList.map((member) => (
          <div className={styles.admin}>
            <Avatar
              className={styles.avatarWrap}
              avatarClassName={styles.avatar}
              src={member.avatarUrl}
              placeholder={convertNameToAvatarPlaceholder(
                `${member.firstName}${member.lastName ? ` ${member.lastName}` : ''}`,
              )}
            />
            <div className={styles.name}>{`${member.firstName}${
              member.lastName ? ` ${member.lastName}` : ''
            }`}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignedAdmins;
